(() => {
  'use strict';
  if (window.VaraprintCatalogSort) return;
  const bound = new WeakMap();
  const watched = new WeakSet();
  const sync = state => {
    const open = getComputedStyle(state.panel).display !== 'none';
    state.trigger.setAttribute('aria-expanded', String(open));
    state.panel.setAttribute('aria-hidden', String(!open));
    state.trigger.setAttribute('aria-label', `${state.label}: ${state.select.selectedOptions[0]?.textContent.trim() || ''}`);
    state.items.forEach((item, i) => item.setAttribute('aria-selected', String(state.select.options[i]?.selected || false)));
  };
  const init = () => {
    document.querySelectorAll('[data-vp-catalog-sort]').forEach(root => {
      if (!watched.has(root)) {
        watched.add(root);
        new MutationObserver(init).observe(root, {childList: true, subtree: true});
      }
      const select = root.querySelector('select'), trigger = root.querySelector('.bv_atual'), panel = root.querySelector('.bv_ul_inner');
      if (!select || !trigger || !panel || bound.get(root)?.trigger === trigger) return;
      const items = [...panel.querySelectorAll('.li:not(.nofocus) a')];
      const state = {root, select, trigger, panel, items, label: root.querySelector('label').textContent.trim()};
      const previous = bound.get(root);
      if (previous) {previous.visibilityObserver.disconnect();previous.select.removeEventListener('change', previous.onChange);}
      bound.set(root, state);
      trigger.setAttribute('role', 'button');trigger.setAttribute('aria-haspopup', 'listbox');trigger.setAttribute('aria-controls', panel.id);
      panel.setAttribute('role', 'listbox');panel.setAttribute('aria-label', state.label);
      items.forEach(item => {item.setAttribute('role', 'option');item.setAttribute('tabindex', '-1');});
      state.visibilityObserver = new MutationObserver(() => sync(state));
      state.visibilityObserver.observe(trigger, {attributes: true, attributeFilter: ['class']});
      state.visibilityObserver.observe(panel, {attributes: true, attributeFilter: ['class', 'style']});
      const focusItem = index => requestAnimationFrame(() => {sync(state);items[index]?.focus();});
      const selected = () => Math.max(0, [...select.options].findIndex(o => o.selected));
      trigger.addEventListener('keydown', event => {
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End', ' ', 'Enter', 'Escape'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Escape') {if (getComputedStyle(panel).display !== 'none') trigger.click();return;}
        const wasOpen = getComputedStyle(panel).display !== 'none';
        if (!wasOpen || event.key === ' ' || event.key === 'Enter') trigger.click();
        if (event.key === 'Home') focusItem(0);
        else if (event.key === 'End') focusItem(items.length - 1);
        else if (!wasOpen || ![' ', 'Enter'].includes(event.key)) focusItem(event.key === 'ArrowUp' ? items.length - 1 : selected());
      });
      panel.addEventListener('keydown', event => {
        const index = items.indexOf(event.target);if (index < 0) return;
        if (event.key === 'Escape') {event.preventDefault();trigger.click();trigger.focus();}
        else if (event.key === 'ArrowDown') {event.preventDefault();focusItem((index + 1) % items.length);}
        else if (event.key === 'ArrowUp') {event.preventDefault();focusItem((index - 1 + items.length) % items.length);}
        else if (event.key === 'Home') {event.preventDefault();focusItem(0);}
        else if (event.key === 'End') {event.preventDefault();focusItem(items.length - 1);}
        else if (event.key === ' ') {event.preventDefault();event.target.click();}
        else if (event.key === 'Tab') trigger.click();
      });
      state.onChange = () => sync(state);
      select.addEventListener('change', state.onChange);sync(state);
      const current = new URL(location.href);
      if (['created-ascending', 'created-descending'].includes(current.searchParams.get('sort_by'))) {
        current.searchParams.set('sort_by', select.value);current.searchParams.delete('page');location.replace(current.href);
      }
    });
  };
  window.VaraprintCatalogSort = {init};
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('collectionSort', init);
  init();
})();
